// TODO: Move to Chops
/**
 * Maps only items that return true for the provided predicate.
 * Useful when editing a single item within a collection.
 *
 * We constrain the mapping function as `T => T` with the assumption that you are
 * still producing an array of the same type.
 *
 * @example
 * mapBy(
 *  x => isOdd(x),
 *  x => x + 1,
 *  [1,2,3,4,5]
 * );
 */
const mapBy = <T>(predicateFn: (x: T) => boolean, mapFn: (x: T) => T, xs: T[]) =>
  xs.map((x) => (predicateFn(x) ? mapFn(x) : x));

export default mapBy;
